import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-folder-plus",
  "use": "icon-folder-plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-folder-plus\" id=\"icon-folder-plus\"><path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\" /><line x1=\"12\" y1=\"11\" x2=\"12\" y2=\"17\" /><line x1=\"9\" y1=\"14\" x2=\"15\" y2=\"14\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol